import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { landingPageAction } from "../../redux/actions/landingPageAction";
import { scroll } from "../../utils/scrollTop";
import { metaData } from "../../utils/metaData";
import Loader from "../../utils/Loader";
const H_1 = lazy(() => import("./H_1"));
const WhytheLeansuit = lazy(() => import("./why_the_leansuit"));
const T_3 = lazy(() => import("./T_3"));
const M_9 = lazy(() => import("./M_9"));
const Digital = lazy(() => import("./Digital"));
const Info = lazy(() => import("../CommonComponent/Info"));
const Footer = lazy(() => import("../CommonComponent/Footer"));

function Home() {
  const dispatch = useDispatch();
  useEffect(() => {
    metaData("1543");
    scroll();
    dispatch(landingPageAction());
  }, [dispatch]);
  const info = useSelector(
    (state) => state?.landingPage?.data?.acf?.section_before_footer
  );
  return (
    <Suspense fallback={<Loader />}>
      <H_1 />
      <M_9 />
      <WhytheLeansuit />
      <T_3 />
      <Digital />
      <Info
        title={info?.title}
        desc={info?.description}
        btn={info?.call_to_action_button?.title}
      />
      <Footer />
    </Suspense>
  );
}
export default Home;